<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>能耗分析</el-breadcrumb-item>
			<el-breadcrumb-item>分类分时统计</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search" @submit.native.prevent>
			<el-form-item label="搜索：">
				<el-popover v-model="visible">
					<el-input ref="deptInput" class="cp" readonly slot="reference" autosize size="small" value="" placeholder="选择部门/集中器"
					 v-model="getJZ"></el-input>
					<div >
						<el-tree v-loading="treeLoad" :data="treeDate" :expand-on-click-node="false" :highlight-current="true"
						 @node-click="handleNodeClick" :props="jzProps" accordion node-key='id'>
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span>
									<i v-if="!data.parentId && !data.isJz" class="el-icon-office-building"></i>
									<i v-if="data.parentId" class="el-icon-location-outline"></i>
									<i v-if="data.isJz" class="el-icon-coin"></i>
									{{ data.departmentName }}
								</span>
							</span>
						</el-tree>
					</div>
				</el-popover>
			</el-form-item>

			<el-form-item>
			  <el-select size="small" v-model="formInline.dateType"  style="width: 120px;"  @change="getDateType">
			    <el-option
			      v-for="item in dateList"

			      :key="item.value"
			      :label="item.lable"
			      :value="item.value">
			    </el-option>
			  </el-select>
			</el-form-item>
      <el-form-item>
         <el-date-picker
            style="width: 120px;"
            @change="getAllData"
            v-if="formInline.dateType == 'day'"
            size="small"
            value-format="yyyy-MM"
            v-model="formInline.monthDate"
            type="month"
            placeholder="选择月">
         </el-date-picker>
         <el-date-picker
            style="width: 120px;"
            @change="getAllData"
            v-if="formInline.dateType == 'month'"
            size="small"
            value-format="yyyy"
            v-model="formInline.yearDate"
            type="year"
            placeholder="选择年">
         </el-date-picker>
      </el-form-item>


		</el-form>

		<!--列表-->
    <div>
      <h3>分类分时能耗统计报表</h3>
      <el-table :data="dataListType" highlight-current-row v-loading="loading"
       border element-loading-text="拼命加载中" style="width: 100%;" height="260"  :header-cell-style="this.$store.state.headerCss" size="small" >
        <el-table-column align="center" type="index" width="60" >
        </el-table-column>
        <el-table-column prop="energytypename" label="能源种类" width="100" ></el-table-column>
        <el-table-column prop="unit" label="单位"  width="100"></el-table-column>
         <el-table-column :label="formInline.date" align="center">
            <el-table-column :prop="item.porp" :label="item.time"  v-for="item in dataListTypeCol" :key="item.id"></el-table-column>

         </el-table-column>
        <el-table-column prop="sumPtion" label="合计" align="center" ></el-table-column>


      </el-table>
    </div>
    <div>

      <div style="display: flex;">

      <h3>分项分时能耗统计报表</h3>
      <el-form inline>

        <el-form-item style="padding: 10px 0 0 20px">
          <el-select size="small" v-model="formInline.energyType" placeholder="选择能源类型"  clearable style="width: 160px;" @change="getEnergyNameDataList">
            <el-option
              v-for="item in energyType"
              :key="item.id"
              :label="item.value"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>


     </div>
      <el-table :data="dataListTime" highlight-current-row v-loading="loadingT"
       border element-loading-text="拼命加载中" style="width: 100%;" height="260" :header-cell-style="this.$store.state.headerCss" size="small" >
        <el-table-column align="center" type="index" width="60" >
        </el-table-column>
        <el-table-column prop="energyusename" label="能源分项"  width="200">
        </el-table-column>

        <el-table-column v-for="item in tableCol" :label="item.time" :prop="item.porp" :key="item.id">
        </el-table-column>
        <el-table-column prop="sumPtion" label="合计" >
        </el-table-column >

      </el-table>
    </div>


	</div>


  </div>
</template>

<script>
	import { findEnergyTypeList,findEnergyNameDataList } from '../../api/analysisMG'
  import {getDepartmentTerminalInfoLis,getTerminalInfoByDepId} from '../../api/energyMG'
	export default {
		data(){
			return{

				// dataList:[],
				loading:false,
        loadingT:false,
        visible:false,
				formInline:{
          dateType:'day',
          monthDate:new Date().getFullYear() + '-' +( new Date().getMonth()+1 < 10 ? '0':'' ) + (new Date().getMonth()+1),
          yearDate:"",
					departmentId:"",
          terId:"",

				  energyType:15,
				},
        user:{},
        dayStr:[],
        getJZ:"",
				dataListType :[],
        dataListTypeCol:[],
        dataListTime:[],
        tableCol:[],
        treeLoad:false,
        treeDate:[],
        energyType:[],
        jzProps: {
        	label: "departmentName",
        	children: 'deps'
        },
        dateList:[
          { value:'day',lable:'逐日' },
          { value:'month',lable:'逐月' },
          { value:'year',lable:'逐年' },

        ],
			}
		},
		created(){
     this.user = JSON.parse(sessionStorage.getItem('userdata'))
     this.getJZ = this.user.departmentName

     this.$store.dispatch('getEnergyTypeConfig').then( (res) => {
     	this.energyType = res
     })


     this.getJzData()
		 this.getData()
     this.getEnergyNameDataList()


		},
		methods:{
			search(){

			},
      getAllData(){
        this.getData()
        this.getEnergyNameDataList()
      },
      getDateType(e){

        if(e == 'day'){
          let dateStr = new Date().getFullYear() + '-' +( d.getMonth()+1 < 10 ? '0':'' ) + (d.getMonth()+1)

          this.formInline.dateType = 'day'
          this.formInline.monthDate = dateStr
          this.formInline.yearDate = ''
        }else if( e == 'month'){

           this.formInline.dateType = 'month'
           this.formInline.monthDate = ''
           this.formInline.yearDate = new Date().getFullYear()+''
        }else{
           this.formInline.dateType = 'year'
           this.formInline.monthDate = ''
           this.formInline.yearDate = ''
        }

        this.getAllData()
      },

			getData(){
        this.loading = true
				findEnergyTypeList(this.formInline).then(res => {
          this.loading = false
					if( res.status == 1 ){
            this.dataListType = res.data.energyTypeDataList
            this.dataListTypeCol = res.data.energytypeuseList[0]
          }
				})
			},
      getEnergyNameDataList(){
        this.loadingT = true

        findEnergyNameDataList(this.formInline).then(res => {
           this.loadingT = false
          if(res.status == 1 ){
            this.dataListTime = res.data.energyDataList
            this.tableCol = res.data.energytypeuseList[0]
          }
        })
      },
      //获取集中器信息
      getJzData: function() {
      	return new Promise((resolve, reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if (res.status == 1) {
      				this.treeDate = this.changeData(res.data.menuDepList)
              //this.getTepIds(this.user.departmentId)
      			} else {
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },
      changeData(data) {
      	data.forEach(item => {
      		if (item.terminalInfo) {
      			if (!item.deps) {
      				item.deps = []
      			}
      			item.terminalInfo.forEach(sitem => {
      				let obj = {}
      				obj.id = sitem.id
      				obj.departmentName = sitem.terminalName
      				obj.terminalCode = sitem.terminalCode
      				obj.isJz = true
      				item.deps.push(obj)
      			})
      		}
      		if (item.deps) {
      			this.changeData(item.deps)
      		}
      	})

      	return data
      },
      handleNodeClick(data) {
      	this.getJZ = data.departmentName
      	if (data.isJz) {

      		this.formInline.terId = data.id
          this.formInline.departmentId = ""

      	} else {
          this.formInline.terId = ""
          this.formInline.departmentId = data.id

      	}

      	this.visible = false
        this.getAllData()
       // this.getTepIds(data.id)
      },

      getTepIds(id){
        // 点击部门获得集中器id
        getTerminalInfoByDepId({
        	depId: id
        }).then(res => {
        	if (res.status == 1) {
        		this.formInline.termianlId = res.data.join('-')
        		this.getAllData()
        	} else {
        		this.$message.error(res.msg)
        	}
        })
      },
      rowClass(){
        return "color:#5c5c5c;background:#fff"
      },
      cellStyle(){
        return "border-color:red"
      }


		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/analysis/typeStatistics.vue